function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 96C0 50.7452 0 28.1177 14.0589 14.0589C28.1177 0 50.7452 0 96 0H99C144.255 0 166.882 0 180.941 14.0589C195 28.1177 195 50.7452 195 96V384C195 429.255 195 451.882 180.941 465.941C166.882 480 144.255 480 99 480H96C50.7452 480 28.1177 480 14.0589 465.941C0 451.882 0 429.255 0 384V96Z",
  fill: "#F25F5C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M309.462 480C292.284 480 283.695 480 276.72 477.827C261.66 473.134 249.866 461.34 245.173 446.28C243 439.305 243 430.716 243 413.538L243 330.462C243 313.284 243 304.695 245.173 297.72C249.866 282.66 261.66 270.866 276.72 266.173C283.695 264 292.284 264 309.462 264L351 264C410.647 264 459 312.353 459 372V372C459 431.647 410.647 480 351 480L309.462 480Z",
  fill: "#F2D95C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M309.462 480C292.284 480 283.695 480 276.72 477.827C261.66 473.134 249.866 461.34 245.173 446.28C243 439.305 243 430.716 243 413.538L243 330.462C243 313.284 243 304.695 245.173 297.72C249.866 282.66 261.66 270.866 276.72 266.173C283.695 264 292.284 264 309.462 264L351 264C410.647 264 459 312.353 459 372V372C459 431.647 410.647 480 351 480L309.462 480Z",
  fill: "black",
  fillOpacity: 0.05
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M459 108C459 167.647 410.647 216 351 216C291.353 216 243 167.647 243 108C243 48.3532 291.353 0 351 0C410.647 0 459 48.3532 459 108Z",
  fill: "#00A693"
});

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 480,
    viewBox: "0 0 459 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9c477d78.svg";
export { ForwardRef as ReactComponent };